import {
  FETCH_INVOICE_COMPANIES,
  FETCH_INVOICE_COMPANIES_SUCCESS,
  FETCH_INVOICE_COMPANIES_FAIL,
  CREATE_INVOICE_COMPANY,
  CREATE_INVOICE_COMPANY_SUCCESS,
  CREATE_INVOICE_COMPANY_FAIL,
  UPDATE_INVOICE_COMPANY,
  UPDATE_INVOICE_COMPANY_SUCCESS,
  UPDATE_INVOICE_COMPANY_FAIL,
  DELETE_INVOICE_COMPANY,
  DELETE_INVOICE_COMPANY_SUCCESS,
  DELETE_INVOICE_COMPANY_FAIL,
  TEST_INVOICE_COMPANY_AADE,
  TEST_INVOICE_COMPANY_AADE_SUCCESS,
  TEST_INVOICE_COMPANY_AADE_FAIL,
  TEST_INVOICE_COMPANY_EPSILON,
  TEST_INVOICE_COMPANY_EPSILON_SUCCESS,
  TEST_INVOICE_COMPANY_EPSILON_FAIL,
  CLEAR_INVOICE_COMPANY_ERROR,
} from "./actionTypes"

// Fetch Invoice Companies
export const fetchInvoiceCompanies = () => ({
  type: FETCH_INVOICE_COMPANIES,
})

export const fetchInvoiceCompaniesSuccess = (companies) => ({
  type: FETCH_INVOICE_COMPANIES_SUCCESS,
  payload: companies,
})

export const fetchInvoiceCompaniesFail = (error) => ({
  type: FETCH_INVOICE_COMPANIES_FAIL,
  payload: error,
})

// Create Invoice Company
export const createInvoiceCompany = (data) => ({
  type: CREATE_INVOICE_COMPANY,
  payload: data,
})

export const createInvoiceCompanySuccess = (company) => ({
  type: CREATE_INVOICE_COMPANY_SUCCESS,
  payload: company,
})

export const createInvoiceCompanyFail = (error) => ({
  type: CREATE_INVOICE_COMPANY_FAIL,
  payload: error,
})

// Update Invoice Company
export const updateInvoiceCompany = (id, data) => ({
  type: UPDATE_INVOICE_COMPANY,
  payload: { id, data },
})

export const updateInvoiceCompanySuccess = (company) => ({
  type: UPDATE_INVOICE_COMPANY_SUCCESS,
  payload: company,
})

export const updateInvoiceCompanyFail = (error) => ({
  type: UPDATE_INVOICE_COMPANY_FAIL,
  payload: error,
})

// Delete Invoice Company
export const deleteInvoiceCompany = (id, hard = false) => ({
  type: DELETE_INVOICE_COMPANY,
  payload: { id, hard },
})

export const deleteInvoiceCompanySuccess = (id) => ({
  type: DELETE_INVOICE_COMPANY_SUCCESS,
  payload: id,
})

export const deleteInvoiceCompanyFail = (error) => ({
  type: DELETE_INVOICE_COMPANY_FAIL,
  payload: error,
})

// Test AADE Connection
export const testInvoiceCompanyAade = (id) => ({
  type: TEST_INVOICE_COMPANY_AADE,
  payload: id,
})

export const testInvoiceCompanyAadeSuccess = (result) => ({
  type: TEST_INVOICE_COMPANY_AADE_SUCCESS,
  payload: result,
})

export const testInvoiceCompanyAadeFail = (error) => ({
  type: TEST_INVOICE_COMPANY_AADE_FAIL,
  payload: error,
})

// Test Epsilon Connection
export const testInvoiceCompanyEpsilon = (id) => ({
  type: TEST_INVOICE_COMPANY_EPSILON,
  payload: id,
})

export const testInvoiceCompanyEpsilonSuccess = (result) => ({
  type: TEST_INVOICE_COMPANY_EPSILON_SUCCESS,
  payload: result,
})

export const testInvoiceCompanyEpsilonFail = (error) => ({
  type: TEST_INVOICE_COMPANY_EPSILON_FAIL,
  payload: error,
})

// Clear Error
export const clearInvoiceCompanyError = () => ({
  type: CLEAR_INVOICE_COMPANY_ERROR,
})
